import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=38c62b9e"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=38c62b9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports